import { gql } from "@apollo/client";

const GET_SKILLS = gql`
  query GetSkills($filters: TagFilter, $domainId: ID) {
    skills(filters: $filters, domainId: $domainId) {
      nodes {
        name
        id
      }
    }
  }
`;

const GET_PROFILE_COUNT_FOR_SKILLS = gql`
  query GetProfileCountForSkills($skills: [TaggableInput!]!) {
    profileCountForSkills(skills: $skills) {
      count
    }
  }
`;

export { GET_PROFILE_COUNT_FOR_SKILLS, GET_SKILLS };
